/**
 * Miscellaneous @apply property sets from src/styles/propertySets.css, as sx objects.
 * Mirrors the source verbatim. Custom-media → literal sx keys:
 * --viewportSmall '@media (min-width:600px)', --viewportMedium '@media (min-width:900px)',
 * --viewportLarge '@media (min-width:1200px)', --viewportLargeWithPaddings '@media (min-width:1304px)',
 * --viewportXLarge '@media (min-width:1921px)'.
 *
 * Asset URLs: relative paths in propertySets.css are resolved at CSS-build time and cannot
 * be used verbatim in sx objects (emotion injects at runtime). The background images are
 * imported here so webpack/Jest resolve them correctly.
 *
 * @param {Record<string,string>} tokens - createTokens() result
 * @returns {Record<string, object>}
 */
import vsBackground from '../../../../assets/VS_Background.jpg';
import vsBackgroundWebp from '../../../../assets/VS_Background.jpg.webp';

export const createMiscStyleMixins = (tokens) => ({
  clearfix: {
    '&::after': {
      content: '""',
      display: 'table',
      clear: 'both',
    },
  },

  backgroundImage: {
    backgroundImage: `linear-gradient(-45deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), url(${vsBackground})`,
    backgroundColor: tokens.matterColor,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },

  backgroundImageWebp: {
    backgroundImage: `linear-gradient(-45deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), url(${vsBackgroundWebp})`,
    backgroundColor: tokens.matterColor,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
});
